import { SxProps } from "@mui/system";
import { Theme } from "@mui/material/styles";

export const sx: SxProps<Theme> = {
  // Target the header container
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#112640",
    color: "white",
    fontSize: "14px",
  },
  // Target individual header cells
  "& .MuiDataGrid-columnHeader": {
    backgroundColor: "#112640",
    color: "white",
    "&:hover": {
      backgroundColor: "#0e3160",
    },
  },
  // Target header text specifically
  "& .MuiDataGrid-columnHeaderTitle": {
    color: "white",
  },
  backgroundColor: "var(--joy-palette-background-body)",
};

const props = {
  columnHeaderHeight: 32,
  rowHeight: 32,
  showColumnVerticalBorder: true,
  showCellVerticalBorder: true,
  disableRowSelectionOnClick: true,
  disableColumnSelector: true,
  disableDensitySelector: true,
  disableVirtualization: true,
  disableColumnMenu: true,
  disableColumnFilter: true,
  sx: sx,
};

export default props;
